"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ICD10_CODE_PATTERN () {
        return ICD10_CODE_PATTERN;
    },
    get Icd10CodeSchema () {
        return Icd10CodeSchema;
    },
    get Icd10SearchItemSchema () {
        return Icd10SearchItemSchema;
    },
    get Icd10SearchRequestSchema () {
        return Icd10SearchRequestSchema;
    },
    get Icd10SearchResponseSchema () {
        return Icd10SearchResponseSchema;
    }
});
const _zod = require("zod");
const ICD10_CODE_PATTERN = /^[A-Z][0-9]{2}(\.[0-9A-Z]{1,2})?$/;
const Icd10CodeSchema = _zod.z.string().regex(ICD10_CODE_PATTERN, {
    message: 'Invalid ICD-10 code format.'
});
const Icd10SearchRequestSchema = _zod.z.object({
    q: _zod.z.string({
        message: 'Search text is required.'
    }).trim().min(2, {
        message: 'Enter at least 2 characters.'
    }).max(60, {
        message: 'Search text must be at most 60 characters.'
    }),
    limit: _zod.z.number({
        message: 'Limit must be a number.'
    }).int({
        message: 'Limit must be a whole number.'
    }).min(1, {
        message: 'Limit must be between 1 and 20.'
    }).max(20, {
        message: 'Limit must be between 1 and 20.'
    }).default(10)
}).strict();
const Icd10SearchItemSchema = _zod.z.object({
    code: Icd10CodeSchema,
    title: _zod.z.string()
}).strict();
const Icd10SearchResponseSchema = _zod.z.object({
    items: _zod.z.array(Icd10SearchItemSchema)
}).strict();
